import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import menuData from "../../Data/MenuData";
import { ChevronDown } from "lucide-react";

const Sidebar = ({ isOpen, toggleSidebar }) => {
  const location = useLocation();
  const [activeMenu, setActiveMenu] = useState(null);
  const isActive = (path) => {
    return (
      location.pathname === path || location.pathname.startsWith(path + "/")
    );
  };
  const isParentActive = (item) => {
    if (item.subMenu) {
      return item.subMenu.some((sub) => isActive(sub.path));
    }
    return isActive(item.path);
  };
  useEffect(() => {
    const active = menuData.find((item) =>
      item.subMenu?.some((sub) => isActive(sub.path)),
    );

    setActiveMenu(active?.id || null);
  }, [location.pathname]);
  const toggleCollapse = (id) => {
    setActiveMenu((prev) => (prev === id ? null : id));
    toggleSidebar();
  };

  return (
    <nav
      className={`sidebar sidebar-offcanvas ${isOpen ? "active" : ""}`}
      id="sidebar"
    >
      <ul className="nav">
        {menuData.map((item, idx) => {
          const isSubMenu = Boolean(item.subMenu);
          const isOpenMenu = item.id === activeMenu;

          return (
            <li
              key={idx}
              className={`nav-item ${isParentActive(item) ? "active" : ""}`}
            >
              {isSubMenu ? (
                <>
                  <div
                    className={`nav-link-parent ${isParentActive(item) ? "active" : ""
                      }`}
                  >
                    <Link
                      className="nav-link d-flex justify-content-between align-items-center"
                      to="#"
                      onClick={() => toggleCollapse(item.id)}
                    >
                      <div className="d-flex align-items-center gap-3">
                        {item.icon && (
                          <item.icon className="menu-icon" size={18} />
                        )}
                        <span className="custom-menu-title">{item.label}</span>
                      </div>

                      <ChevronDown
                        className={`menu-icon transition ${isOpenMenu ? "rotate-180" : ""
                          }`}
                        size={18}
                      />
                    </Link>
                  </div>
                  <div
                    className={`collapse ${isOpenMenu ? "show" : ""}`}
                    id={item.id}
                  >
                    <ul className="nav flex-column sub-menu">
                      {item.subMenu.map((sub, subIdx) => (
                        <li
                          key={subIdx}
                          className={`nav-item ${isActive(sub.path) ? "active" : ""
                            }`}
                        >
                          <Link
                            className="nav-link"
                            to={sub.path}
                            onClick={toggleSidebar}
                          >
                            <i className="fa-solid fa-arrow-right" />
                            <span className="custom-menu-subtitle mx-1">
                              {sub.label}
                            </span>
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                </>
              ) : (
                <div
                  className={`nav-link-parent ${isParentActive(item) ? "active" : ""
                    }`}
                >
                  <Link
                    className="nav-link d-flex align-items-center"
                    to={item.path}
                    onClick={toggleSidebar}
                  >
                    <div className="d-flex align-items-center gap-3">
                      {item.icon && (
                        <item.icon className="menu-icon" size={18} />
                      )}
                      <span className="custom-menu-title">{item.label}</span>
                    </div>
                  </Link>
                </div>
              )}
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export default Sidebar;
